/** Pure barrel — re-exports only side-effect-free modules */
export * from "./xml.interfaces";
export * from "./xml.serializer";
export * from "./xml.serializer.format";
export * from "./xml.builder";
export * from "./xml.builder.string";
export * from "./xml.builder.bytes";
